import React, { useState } from 'react';
import { PS } from '../theme';
import { Icon } from '../lib/icons';
import { thb } from '../lib/format';

// Per-head dok model (สอดคล้องกับคู่มือ):
//   fullPot = ยอดต่องวด × จำนวนมือ
//   ดอกรวม = ดอกต่อมือ × (จำนวนมือ − 1)
//   ดอกหัก: รับงวดนี้ = fullPot − ดอกรวม · งวดถัดไปจ่ายเต็มต้น
//   ดอกตาม: รับงวดนี้ = fullPot เต็ม · งวดถัดไปจ่าย ต้น + ดอก
export function calcDok(amount, members, bid, mode) {
  const a = Number(amount) || 0;
  const m = Math.max(1, Number(members) || 1);
  const b = Math.max(0, Number(bid) || 0);
  const fullPot = a * m;
  const totalDok = b * Math.max(0, m - 1);
  if (mode === 'hak') return { receive: fullPot - totalDok, nextPay: a, totalDok, fullPot };
  return { receive: fullPot, nextPay: a + b, totalDok, fullPot };
}

const DOK_INFO = {
  tam: { label: 'ดอกตาม', desc: 'รับเต็มก่อน · ผ่อนดอกทีหลังทุกงวด' },
  hak: { label: 'ดอกหัก', desc: 'ถูกหักดอกตอนรับ · งวดหลังจ่ายเต็มต้น' },
};

export default function DokCalculator({ amount, members, mode = 'tam', defaultBid = 0 }) {
  const [bid, setBid] = useState(defaultBid || Math.round(amount * 0.1) || 0);
  const r = calcDok(amount, members, bid, mode);
  const info = DOK_INFO[mode] || DOK_INFO.tam;
  const quick = [0.05, 0.1, 0.15, 0.2].map(p => Math.round(amount * p)).filter(v => v > 0);

  return (
    <div data-testid="dok-calculator" style={{ background: PS.ink, color: PS.page, borderRadius: 16, padding: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <Icon.coin size={16} stroke="oklch(0.82 0.1 82)" />
        <div style={{ fontSize: 12.5, fontWeight: 600 }}>ลองคำนวณดอก · โหมด{info.label}</div>
        <div style={{ marginLeft: 'auto', fontSize: 10.5, color: 'rgba(245,241,234,0.55)' }}>{members} มือ</div>
      </div>

      <div style={{ fontSize: 10.5, color: 'rgba(245,241,234,0.55)', letterSpacing: 0.6, textTransform: 'uppercase', marginBottom: 6 }}>ดอกที่จะเปีย (ต่อมือ)</div>
      <input data-testid="dok-bid-input" type="number" value={bid} onChange={e => setBid(e.target.value)} className="num"
        style={{ width: '100%', height: 46, borderRadius: 12, background: 'rgba(245,241,234,0.08)', border: '1px solid rgba(245,241,234,0.14)', color: PS.page, padding: '0 14px', fontSize: 17, outline: 'none' }} />
      <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
        {quick.map(v => (
          <button key={v} data-testid={`dok-quick-${v}`} onClick={() => setBid(v)} className="ps-press num" style={{ flex: 1, height: 34, borderRadius: 9, background: bid == v ? 'oklch(0.72 0.12 82)' : 'rgba(245,241,234,0.08)', color: bid == v ? PS.ink : PS.page, border: 'none', fontSize: 12.5, fontWeight: 600 }}>฿{v.toLocaleString()}</button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 14 }}>
        <div style={{ background: 'rgba(245,241,234,0.06)', borderRadius: 12, padding: 12 }}>
          <div style={{ fontSize: 10, color: 'rgba(245,241,234,0.6)', letterSpacing: 0.5, textTransform: 'uppercase' }}>รับงวดนี้ (ถ้าเปียชนะ)</div>
          <div data-testid="dok-receive" className="num" style={{ fontSize: 22, fontWeight: 500, marginTop: 5, color: 'oklch(0.85 0.1 150)' }}>{thb(r.receive)}</div>
        </div>
        <div style={{ background: 'rgba(245,241,234,0.06)', borderRadius: 12, padding: 12 }}>
          <div style={{ fontSize: 10, color: 'rgba(245,241,234,0.6)', letterSpacing: 0.5, textTransform: 'uppercase' }}>จ่ายงวดถัดไป</div>
          <div data-testid="dok-nextpay" className="num" style={{ fontSize: 22, fontWeight: 500, marginTop: 5 }}>{thb(r.nextPay)}</div>
        </div>
      </div>
      <div style={{ fontSize: 11, color: 'rgba(245,241,234,0.6)', lineHeight: 1.55, marginTop: 10 }}>
        {mode === 'hak'
          ? `ดอกหัก: ถูกหักดอกรวม ฿${r.totalDok.toLocaleString()} ตอนรับ (เหลือ ${thb(r.receive)}) · งวดต่อไปส่งเต็มต้น ${thb(r.nextPay)}`
          : `ดอกตาม: รับเต็ม ${thb(r.receive)} ก่อน · จากนั้นจ่ายต้น+ดอก ${thb(r.nextPay)} ทุกงวดจนจบ`}
      </div>
      <div style={{ fontSize: 10, color: 'rgba(245,241,234,0.4)', marginTop: 8 }}>รอเปียท้ายๆ (มือตาย) จะได้ดอกสะสมจากทุกคนที่เปียก่อน — คุ้มกว่าฝากประจำ</div>
    </div>
  );
}
